// extracted by mini-css-extract-plugin
module.exports = {"toggle":"DarkModeToggle_toggle__5xJQ5"};